var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V20C32 21.1046 31.1046 22 30 22H2C0.895431 22 0 21.1046 0 20V2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.179 15.7995C14.9949 16.7975 13.459 17.4 11.7807 17.4C8.03582 17.4 5 14.4003 5 10.7C5 6.99969 8.03582 4 11.7807 4C13.459 4 14.9949 4.6025 16.179 5.60054C17.363 4.6025 18.8989 4 20.5773 4C24.3221 4 27.358 6.99969 27.358 10.7C27.358 14.4003 24.3221 17.4 20.5773 17.4C18.8989 17.4 17.363 16.7975 16.179 15.7995Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.179 15.7995C17.6369 14.5706 18.5614 12.742 18.5614 10.7C18.5614 8.65804 17.6369 6.82944 16.179 5.60054C17.363 4.6025 18.8989 4 20.5772 4C24.3221 4 27.3579 6.99969 27.3579 10.7C27.3579 14.4003 24.3221 17.4 20.5772 17.4C18.8989 17.4 17.363 16.7975 16.179 15.7995Z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.179 15.7995C17.6369 14.5706 18.5614 12.742 18.5614 10.7C18.5614 8.65808 17.6369 6.82949 16.179 5.60059C14.7211 6.82949 13.7966 8.65808 13.7966 10.7C13.7966 12.742 14.7211 14.5706 16.179 15.7995Z",
    fill: "#FF5E00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.25H30V-0.25H2V0.25ZM31.75 2V20H32.25V2H31.75ZM30 21.75H2V22.25H30V21.75ZM0.25 20V2H-0.25V20H0.25ZM2 21.75C1.0335 21.75 0.25 20.9665 0.25 20H-0.25C-0.25 21.2426 0.757359 22.25 2 22.25V21.75ZM31.75 20C31.75 20.9665 30.9665 21.75 30 21.75V22.25C31.2426 22.25 32.25 21.2426 32.25 20H31.75ZM30 0.25C30.9665 0.25 31.75 1.0335 31.75 2H32.25C32.25 0.757359 31.2426 -0.25 30 -0.25V0.25ZM2 -0.25C0.757359 -0.25 -0.25 0.757359 -0.25 2H0.25C0.25 1.0335 1.0335 0.25 2 0.25V-0.25Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.2155ce12e6deee8aad531094110f41a3.svg";
export { ForwardRef as ReactComponent };